var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 80,
        "footer-hide": true,
        title: "质检不合格通知书明细",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    {
                      staticClass: "small-form",
                      attrs: { "label-position": "top" },
                    },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "转运站" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.record.distributionStationName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "苗场" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.record.seedFarmName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "专家" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.record.masterName,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "苗场答复" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.record
                                          .qualifyFailReportRecordSeedFarmResponse,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "专家答复" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.record
                                          .qualifyFailReportRecordMasterResponse,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "提出时间" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateTimeString(
                                        _vm.record
                                          .qualifyFailReportRecordCreateAt
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "苗场回复时限" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateTimeString(
                                        _vm.record
                                          .qualifyFailReportRecordDelayedExpire
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Form",
                {
                  staticClass: "small-form",
                  attrs: { "label-position": "top" },
                },
                [
                  _vm.record.qualifyFailReportRecordSeedFarmResponse === "" &&
                  _vm.$checkAccessArray(["B", "C"])
                    ? [
                        _c(
                          "Col",
                          { attrs: { span: "6" } },
                          [
                            _c(
                              "FormItem",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "苗场答复\n                            "
                                    ),
                                    _c(
                                      "Button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.onSeedFarmResponse },
                                      },
                                      [_vm._v("提交")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "RadioGroup",
                                  {
                                    model: {
                                      value: _vm.seedFarmResponse,
                                      callback: function ($$v) {
                                        _vm.seedFarmResponse = $$v
                                      },
                                      expression: "seedFarmResponse",
                                    },
                                  },
                                  [
                                    _c("Radio", { attrs: { label: "同意" } }, [
                                      _vm._v("同意，退款"),
                                    ]),
                                    _c(
                                      "Radio",
                                      { attrs: { label: "不同意" } },
                                      [_vm._v("不同意，申请仲裁")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.$checkAccessArray(["B", "C"])
                    ? [
                        _c(
                          "Col",
                          { attrs: { span: "3" } },
                          [
                            _c(
                              "FormItem",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "延时回复\n                            "
                                    ),
                                    _c(
                                      "Button",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.record
                                              .qualifyFailReportRecordUseDelayed !==
                                            0,
                                          type: "primary",
                                        },
                                        on: { click: _vm.onApplyDelayed },
                                      },
                                      [_vm._v("提交")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("Input", {
                                  attrs: {
                                    value:
                                      _vm.record
                                        .qualifyFailReportRecordUseDelayed === 0
                                        ? "未申请"
                                        : "已申请",
                                    readonly: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Form",
                {
                  staticClass: "small-form",
                  attrs: { "label-position": "top" },
                },
                [
                  _vm.record.qualifyFailReportRecordSeedFarmResponse ===
                    "不同意" &&
                  _vm.record.qualifyFailReportRecordMasterResponse === "" &&
                  _vm.$checkAccessArray(["A"])
                    ? [
                        _c(
                          "Col",
                          { attrs: { span: "6" } },
                          [
                            _c(
                              "FormItem",
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "专家答复\n                            "
                                    ),
                                    _c(
                                      "Button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.onMasterResponse },
                                      },
                                      [_vm._v("提交")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "RadioGroup",
                                  {
                                    model: {
                                      value: _vm.masterResponse,
                                      callback: function ($$v) {
                                        _vm.masterResponse = $$v
                                      },
                                      expression: "masterResponse",
                                    },
                                  },
                                  [
                                    _c(
                                      "Radio",
                                      { attrs: { label: "苗场退款" } },
                                      [_vm._v("苗场责任，退款")]
                                    ),
                                    _c(
                                      "Radio",
                                      { attrs: { label: "无需退款" } },
                                      [_vm._v("无需退款")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "Row",
            { staticClass: "row-margin-top-15", attrs: { gutter: 16 } },
            [
              _c(
                "Button",
                {
                  attrs: {
                    disabled: _vm.record.qualifyFailReportRecordImages === "",
                    type: "warning",
                  },
                  on: { click: _vm.loadCheckImage },
                },
                [_vm._v("查看质检图片")]
              ),
            ],
            1
          ),
          _c(
            "Row",
            {
              staticClass: "row-margin-top-15",
              staticStyle: { "margin-top": "20px" },
              attrs: { gutter: 16 },
            },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("b", [_vm._v("质检产品")]),
                  _c("Table", {
                    ref: "mainTable",
                    attrs: {
                      size: "small",
                      columns: _vm.mainTable.columns,
                      data: _vm.details,
                      "highlight-row": "",
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }